module.exports = __webpack_public_path__ + "img/Farms Icon.dc76634f.svg";